import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, Card, CardBody, Form, Row, Col, FormGroup, Input, Collapse } from "reactstrap";
import VistoriaOnlineQuestionario from './VistoriaOnlineQuestionario';
import InputFile from "../../../components/Inputs/InputFile.jsx";

// helpers
import { showMessage } from "../../../helpers/message.js";
import { formateDateAndTimeApi } from '../../../helpers/formats';
import { InputCEP } from "../../../helpers/mask.js";

// api
import cep_api from "../../../api/cep_api";

// views
import VistoriaOnlineListaBoletinsVinculados from './VistoriaOnlineListaBoletinsVinculados';

export default function VistoriaOnlineInspecao({ formularioVistoria, handleFinalizarInspecao, handleCancelar, boletinsVinculados }) {

    const { register, errors, getValues, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [showBoletinsVinculados, set_showBoletinsVinculados] = useState(false);
    const [showQuestionario, set_showQuestionario] = useState(false);
    const [dataInicio, set_dataInicio] = useState(null);
    const [arquivos, set_arquivos] = useState([]);

    const handleFile = (file) => {
        if (file) {
            let _files = arquivos.filter(f => f.id != file.id);
            _files.push(file);
            set_arquivos(_files);
        }
    }

    const handleCEP = (event) => {
        clearErrors("cep");

        if (event.target.value.length != 9)
            return;

        cep_api.get(event.target.value).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", "Cep não localizado", 'warning', null);
                setValue("logradouro", "");
                setValue("bairro", "");
                setValue("cidade", "");
                setValue("uf", "");
            }
            else {
                setValue("logradouro", result.data.logradouro);
                setValue("bairro", result.data.bairro);
                setValue("cidade", result.data.localidade);
                setValue("uf", result.data.uf);
            }
        });
    }

    const handleIniciarQuestionario = () => {
        if (arquivos.length < formularioVistoria.totalFotosInspecao) {
            showMessage("Aviso", `É necessário importar no mínimo ${formularioVistoria.totalFotosInspecao} arquivos/fotos para esta inspeção`, 'error', null);
            return;
        }
        set_dataInicio(formateDateAndTimeApi(new Date()));
        set_showQuestionario(true);
    }

    const handleFinalizar = (questoesExecutadas) => {
        let data = getValues();

        let obj = {
            local: data.local,
            cep: data.cep,
            logradouro: data.logradouro,
            numero: data.numero,
            complemento: data.complemento,
            bairro: data.bairro,
            cidade: data.cidade,
            uF: data.uf,
            dataHoraInicio: dataInicio,
            dataHoraFim: formateDateAndTimeApi(new Date()),
            boletimVistoriaQuestoes: questoesExecutadas,
            boletimVistoriaInspecaoFotos: arquivos
        }

        handleFinalizarInspecao(obj);
    }

    return (
        <>
            <Card>
                <CardBody>
                    {boletinsVinculados != null && boletinsVinculados.length > 0 &&
                        <>
                            <h5 Style={{ cursor: "pointer" }} className="subtitleCard" onClick={() => set_showBoletinsVinculados(!showBoletinsVinculados)}>Boletins Vinculados para Análise
                                &nbsp;<i className={showBoletinsVinculados ? "fas fa-chevron-down fa-cursor" : "fas fa-chevron-up fa-cursor"}></i>
                            </h5>
                            <Collapse isOpen={showBoletinsVinculados}>
                                <VistoriaOnlineListaBoletinsVinculados boletinsVinculados={boletinsVinculados}></VistoriaOnlineListaBoletinsVinculados>
                            </Collapse>
                        </>
                    }
                    <Row>
                        <Col lg="12" md="12" sm="12" className="text-right">
                            <strong className="text-danger">* Campos Obrigatórios</strong>
                        </Col>
                    </Row>
                    <h5 className="subtitleCard">Local da Inspeção</h5>
                    <Row className="align-items-end">
                        <Col lg="12" md="12" sm="12">
                            <FormGroup>
                                <label className="form-control-label">Descrição do Local</label>
                                <Input className="form-control"
                                    autocomplete="off"
                                    type="text"
                                    name="local"
                                    maxLength="150"
                                    innerRef={register({ required: true })}
                                    readOnly={showQuestionario}
                                />
                                {errors.local && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3" lg="3">
                            <FormGroup>
                                <label className="form-control-label">CEP</label>
                                <InputCEP name="cep" onBlur={handleCEP} inputRef={register({ required: true })} readOnly={showQuestionario} />
                                {errors.cep && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col md="5" lg="5">
                            <FormGroup>
                                <label className="form-control-label">Logradouro</label>
                                <Input type="text" readonly="readonly" name="logradouro" innerRef={register({ required: true })} maxLength="150" />
                                {errors.logradouro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col md="4" lg="4">
                            <FormGroup>
                                <label className="form-control-label">Bairro</label>
                                <Input type="text" readonly="readonly" name="bairro" innerRef={register({ required: true })} maxLength="150" />
                                {errors.bairro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col md="2" lg="2">
                            <FormGroup>
                                <label className="form-control-label">Número</label>
                                <Input type="number" name="numero" innerRef={register({ required: true })} readOnly={showQuestionario} />
                                {errors.numEndereco && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col md="3" lg="3">
                            <FormGroup>
                                <label className="form-control-label">Complemento</label>
                                <Input type="text" name="complemento" innerRef={register({ required: false })} maxLength="150" readOnly={showQuestionario} />
                            </FormGroup>
                        </Col>
                        <Col md="5" lg="5">
                            <FormGroup>
                                <label className="form-control-label">Cidade</label>
                                <Input type="text" readonly="readonly" name="cidade" innerRef={register({ required: true })} maxLength="150" />
                                {errors.cidade && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col md="2" lg="2">
                            <FormGroup>
                                <label className="form-control-label">UF</label>
                                <Input type="text" readonly="readonly" name="uf" innerRef={register({ required: true })} maxLength="50" />
                                {errors.uf && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12" md="12" sm="12">
                            <label className="form-control-label">* Mínimo de {formularioVistoria.totalFotosInspecao} arquivos/fotos</label>
                        </Col>
                        <Col lg="3" md="6" sm="12" className="text-center">
                            <FormGroup>
                                <label className="form-control-label">Anexo 1</label><br />
                                <InputFile height="4rem" width="4rem"
                                    name="anexo1"
                                    id="anexo1"
                                    readOnly={showQuestionario}
                                    handlefile={handleFile}>
                                </InputFile>
                            </FormGroup>
                        </Col>
                        <Col lg="3" md="6" sm="12" className="text-center">
                            <FormGroup>
                                <label className="form-control-label">Anexo 2</label><br />
                                <InputFile height="4rem" width="4rem"
                                    name="anexo2"
                                    id="anexo2"
                                    readOnly={showQuestionario}
                                    handlefile={handleFile}>
                                </InputFile>
                            </FormGroup>
                        </Col>
                        <Col lg="3" md="6" sm="12" className="text-center">
                            <FormGroup>
                                <label className="form-control-label">Anexo 3</label><br />
                                <InputFile height="4rem" width="4rem"
                                    name="anexo3"
                                    id="anexo3"
                                    readOnly={showQuestionario}
                                    handlefile={handleFile}>
                                </InputFile>
                            </FormGroup>
                        </Col>
                        <Col lg="3" md="6" sm="12" className="text-center">
                            <FormGroup>
                                <label className="form-control-label">Anexo 4</label><br />
                                <InputFile height="4rem" width="4rem"
                                    name="anexo4"
                                    id="anexo4"
                                    readOnly={showQuestionario}
                                    handlefile={handleFile}>
                                </InputFile>
                            </FormGroup>
                        </Col>
                    </Row>
                    {!showQuestionario &&
                        <Row>
                            <Col lg="12" md="12" sm="12" className="text-center">
                                <Button color="default" type="button" onClick={handleCancelar}>
                                    Cancelar
                                </Button>
                                <Button color="success" type="button" onClick={handleIniciarQuestionario}>
                                    <i className="fas fa-play"></i>  Iniciar Questionário
                                </Button>
                            </Col>
                        </Row>
                    }
                </CardBody>
            </Card>
            {showQuestionario &&
                <VistoriaOnlineQuestionario
                    formularioVistoria={formularioVistoria}
                    handleFinalizarQuestionario={handleFinalizar}
                />
            }
        </>
    );
}

